import React, { Component, createRef } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import { BASE_URL, attendeeTypeActionId, cityActionId, countryActionId, countryIWithCodeActionId, exhibitorBadgeDaysActionId, pincodeActionId, visitorTypeListActionId, stateActionId, toastError, GSTvalidationActionId, visitPurposeActionId, seminarInterestActionId, companyTurnOverActionId, exhibitionStatusActionId, toastSuccess, industryChaptersActionId, genderActionId, AccountTypeActionId, primaryChapterListActionId, B2BTimeslotActionID, visitorInterestActionId } from "../../../utils/constants";
import { Tab, Nav, ToggleButton, ButtonGroup, Container, Row, Stack } from "react-bootstrap";
import { fill_action } from "../../../actions/fillCombo_action"
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import moment from "moment";
import { getExhNoteDetails_action } from "../../../actions/admin_module_action/master_action/exhibition_master_action/exh_note_action"
import DatePicker from "react-datepicker";
import { getVistiorRegistarionDetails_action, visitorRegistrationNext_action, verifyVisitorEmail_action, visitorRegistrationGroupNext_action, delVisaDoc_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { getDelegateCombineDetails_action, delegateRegistrationCombineSubmit_action, getDelegateFirldList_action } from "../../../actions/delegate_module_action/delegate_form_action/delegate_form_action"
import Resizer from "react-image-file-resizer";
import { data } from "jquery";
import { combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action } from "../../../actions/visitor_module_action/visitor_form_action/visitor_form_action"
import { emailValidator } from "../../../utils/Validator";
import Modal from "react-modal";
import { getVisitorRegistrationCredentials_action, getCoordinatorVisitor_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action";
import { payment_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { getDelegatePreviewDetails_action, delegatePreviewSubmit_action, deleteVisaDoc_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action";
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
import { getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/delegate_dashboard_action"
import { getItenaryUser_action, insertUpdateItineraryNote_action, getItineraryNoteDetails_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/itenary_user_action"
import ReactDOMServer from "react-dom/server";
import "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";
class ItenaryUser extends Component {

    // Initialize Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            itenaryList: [],
            exhibitionData: [],
            isOpen: false,
            ItneryDeatailIdObj: {},
            Note: '',
            itiPath: '',
        }
        this.pdfContainerRef = createRef();
        this.getItenaryUser = this.getItenaryUser.bind(this)
    }

    openPrintView = () => {
        this.setState({ isLoading: true });

        const content = document.getElementById("itinerary-pdf");

        if (!content) {
            this.setState({ isLoading: false });
            return;
        }

        const currentDateTime = moment().format("DD MMM YYYY hh:mm A");

        let html = content.outerHTML;

        // Remove bootstrap flex layout for print
        html = html.replaceAll(
            "p-0 m-0 d-flex justify-content-between",
            "p-0 m-0"
        );

        // Remove bootstrap text-center classes
        html = html.replaceAll("text-center", "text-left");

        // Remove center alignments
        html = html.replace(/text-align\s*:\s*center/gi, "text-align:left");
        html = html.replace(/align=['"]center['"]/gi, "");

        // Remove center tags
        html = html.replace(/<center>/gi, "<div>");
        html = html.replace(/<\/center>/gi, "</div>");

        // Convert UL/LI to DIV for better print layout
        html = html.replace(/<ul[^>]*>/gi, "<div>");
        html = html.replace(/<\/ul>/gi, "</div>");
        html = html.replace(/<li[^>]*>/gi, "<div>");
        html = html.replace(/<\/li>/gi, "</div>");

        const printFrame = document.createElement("iframe");

        printFrame.style.position = "fixed";
        printFrame.style.right = "0";
        printFrame.style.bottom = "0";
        printFrame.style.width = "0";
        printFrame.style.height = "0";
        printFrame.style.border = "0";

        document.body.appendChild(printFrame);

        const doc = printFrame.contentWindow.document;

        doc.open();

        doc.write(`
        <html>
        <head>
            <title>Itinerary</title>

            <style>
    body{
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 15px;
    }

    table{
        width:100%;
        border-collapse:collapse;
    }

    table,
    th,
    td{
        border:1.5px solid #333 !important;
    }

    th,
    td{
        padding:8px;
    }

    th{
        text-align:center;
        font-weight:bold;
    }

    .bi,
    button,
    .btn{
        display:none !important;
    }

    .text-aqua{
        color:#3dbca7 !important;
        display:block;
        text-align:left !important;
        margin-top:4px;
        font-weight:500;
    }

    /* Date & Time columns */
    table td:first-child,
    table td:nth-child(2),
    table th:first-child,
    table th:nth-child(2){
        text-align:center !important;
        vertical-align:middle !important;
    }

    /* Activities column ONLY */
    table td:last-child{
        text-align:left !important;
        vertical-align:top !important;
        padding-left:10px !important;
    }

    table td:last-child,
    table td:last-child *,
    table td:last-child div,
    table td:last-child span,
    table td:last-child p{
        text-align:left !important;
        vertical-align:top !important;
        justify-content:flex-start !important;
        align-items:flex-start !important;
    }

    table td:last-child > div{
        width:100% !important;
        text-align:left !important;
    }

    /* Remove bullets */
    ul,
    li{
        list-style:none !important;
        margin:0 !important;
        padding:0 !important;
    }

    /* Remove bootstrap flex alignment in print */
    .d-flex{
        justify-content:flex-start !important;
        align-items:flex-start !important;
    }

    /* Maps */
    iframe{
        width:320px !important;
        height:220px !important;
        border:none !important;
        display:block !important;
        margin:5px 0 !important;
    }

    /* Avoid row breaking */
    tr{
        page-break-inside:avoid !important;
        break-inside:avoid !important;
    }

    td,
    th{
        page-break-inside:avoid !important;
        break-inside:avoid !important;
    }

    thead{
        display:table-header-group !important;
    }

    .table-responsive{
        overflow:visible !important;
    }

    @page{
        size:A4;
        margin:8mm;
    }
</style>
        </head>

        <body>

            <div
                style="
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    margin-bottom:10px;
                    padding-bottom:5px;
                    border-bottom:1px solid #ddd;
                "
            >
                <div
                    style="
                        font-size:18px;
                        font-weight:bold;
                    "
                >
                    Delegate Itinerary
                </div>

                <div
                    style="
                        font-size:12px;
                        font-weight:bold;
                    "
                >
                    Generated On: ${currentDateTime}
                </div>
            </div>

            ${html}

        </body>
        </html>
    `);

        doc.close();

        printFrame.onload = () => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();

            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 3000);
        };

        setTimeout(() => {
            this.setState({ isLoading: false });
        }, 3000);
    };

    componentDidMount() {
        this.getItenaryUser()
    }
    getItenaryUser() {
        const { typeID, typeList, productAll, companyAll, countryAll } = this.state
        this.setState({ isLoading: true })

        return new Promise((resolve => {
            this.props.getItenaryUser_action(false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS'))?.DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS'))?.DelegateRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data, 'xx')
                        const itenaryData = data.data[0]
                        const exhibitionData = data.data[1][0]

                        for (var a = 0; a < itenaryData.length; a++) {
                            for (var b = 0; b < itenaryData.length - 1 - a; b++) {
                                let dateA = new Date(itenaryData[b].Date);
                                let dateB = new Date(itenaryData[b + 1].Date);

                                let datePartA = dateA.toISOString().split('T')[0];
                                let datePartB = dateB.toISOString().split('T')[0];

                                if (datePartA == datePartB) {
                                    // Swap the elements if they are in the wrong order
                                    if (dateA > dateB) {
                                        [itenaryData[b], itenaryData[b + 1]] = [itenaryData[b + 1], itenaryData[b]];
                                    }
                                }
                            }
                        }
                        console.log(itenaryData)
                        var DateArr = []
                        var DateArrofObj = []
                        for (var b = 0; b < itenaryData.length; b++) {
                            if (!DateArr.includes(itenaryData[b].Date)) {
                                DateArr.push(itenaryData[b].Date)
                            }
                        }
                        for (var a = 0; a < DateArr.length; a++) {
                            var count = 0
                            for (var b = 0; b < itenaryData.length; b++) {
                                if (itenaryData[b].Date == DateArr[a]) {
                                    count++
                                }
                            }
                            var countObj = {
                                Date: DateArr[a],
                                Available: 1,
                                count: count
                            }
                            DateArrofObj.push(countObj)
                        }

                        console.log(DateArrofObj)

                        for (var b = 0; b < itenaryData.length; b++) {
                            itenaryData[b].rowspan = null
                            for (var a = 0; a < DateArrofObj.length; a++) {
                                if (DateArrofObj[a].Available == 1) {
                                    if (itenaryData[b].Date == DateArrofObj[a].Date) {
                                        // console.log('ooo',a,b,count,DateArr[a])
                                        itenaryData[b].rowspan = DateArrofObj[a].count
                                        DateArrofObj[a].Available = 0
                                        break
                                    }
                                }
                            }
                        }
                        console.log(itenaryData)

                        for (var a = 0; a < itenaryData.length; a++) {
                            var mapHtmlArr = itenaryData[a].MapUrl != null ? itenaryData[a].MapUrl.split(' ') : []
                            for (var i = 0; i < mapHtmlArr.length; i++) {
                                if (mapHtmlArr[i].includes('width')) {
                                    var widthArr = mapHtmlArr[i].split('=')
                                    // mapHtmlArr[i].split('=')[1] = "200"
                                    var newWidth = mapHtmlArr[i].replace(`${mapHtmlArr[i].split('=')[1]}`, '"400"')
                                }
                                if (mapHtmlArr[i].includes('height')) {
                                    var newHeightArr = mapHtmlArr[i].split('=')
                                    // mapHtmlArr[i].split('=')[1] = "200"
                                    var newHeight = mapHtmlArr[i].replace(`${mapHtmlArr[i].split('=')[1]}`, '"400"')
                                }
                            }
                            for (var i = 0; i < mapHtmlArr.length; i++) {
                                if (mapHtmlArr[i].includes('width')) {
                                    mapHtmlArr[i] = newWidth
                                }
                                if (mapHtmlArr[i].includes('height')) {
                                    mapHtmlArr[i] = newHeight
                                }
                            }
                            var mapHtml = mapHtmlArr.join(' ')
                            itenaryData[a].MapUrl = mapHtml
                        }
                        console.log(itenaryData)
                        this.setState({ itenaryList: itenaryData, exhibitionData: exhibitionData })
                        this.setState({ isLoading: false, itiPath: data.data[2] ? data.data[2][0] ? data.data[2][0].ItenaryPath : '' : '' }, () => {
                            this.PdfRender()
                        })
                    }
                })
        }))
    }

    onPrintClick(e) {
        // this.setState({ isLoading: true });
        const url = `${BASE_URL.split("/api")[0]}${this.state.itiPath}`;
        const win = window.location.replace(url, "_blank");
        if (win != null) {
            win.focus();
        }
    }

    insertUpdateItineraryNote() {
        const { ItneryDeatailIdObj, Note } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.insertUpdateItineraryNote_action(ItneryDeatailIdObj.ItineraryNoteID, ItneryDeatailIdObj.DelegateSeminarDetailsID, ItneryDeatailIdObj.B2BMeetingID, ItneryDeatailIdObj.DelegateItineraryID, Note?.trim() ? Note : null, ItneryDeatailIdObj.ExhibitorItineraryID, ItneryDeatailIdObj.ExhibitorSeminarDetailsID, ItneryDeatailIdObj.VisitorItineraryID, ItneryDeatailIdObj.ExhvisitorSeminarDetailsID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Note Updated Successfully")
                        this.getItenaryUser()
                        this.setState({ isOpen: false, Note: '' })
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
        }))
    }

    getItineraryNoteDetails() {
        const { ItneryDeatailIdObj, Note } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.getItineraryNoteDetails_action(ItneryDeatailIdObj.ItineraryNoteID)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false, Note: data.data?.[0]?.Note ?? '' })
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
        }))
    }

    onPop(item) {
        this.setState({
            isOpen: true,
            ItneryDeatailIdObj: {
                ItineraryNoteID: item.ItineraryNoteID,
                DelegateSeminarDetailsID: item.DelegateSeminarDetailsID,
                B2BMeetingID: item.B2BMeetingID,
                DelegateItineraryID: item.DelegateItineraryID,
                ExhibitorItineraryID: item.ExhibitorItineraryID,
                ExhibitorSeminarDetailsID: item.ExhibitorSeminarDetailsID,
                VisitorItineraryID: item.VisitorItineraryID,
                ExhvisitorSeminarDetailsID: item.ExhvisitorSeminarDetailsID,
            },
            Note: item.Note ?? ''
        },
            // () => this.getItineraryNoteDetails()
        )
    }

    async PdfRender() {
        const { itiPath, itiFile } = this.state;
        // console.log("IntAreaRules--------------------------------------------->", IntAreaRules)
        // if (!IntRulesPath) return;

        const container = this.pdfContainerRef.current;
        // console.log("container--------------------------------------------->", container)
        if (!container) return;

        container.innerHTML = ""; // clear old pages

        // const url = IntAreaRules
        console.log('itiPath, itiFile', itiPath, itiFile)
        try {
            const url = `${BASE_URL.split("/api")[0]}${itiPath}`;
            var pdf = ''
            // if (itiFile != '' && itiFile != null) {
            //     const base64 = itiFile.split(",")[1];
            //     // Convert Base64 → Uint8Array
            //     const binaryString = atob(base64);
            //     const bytes = new Uint8Array(binaryString.length);
            //     for (let i = 0; i < binaryString.length; i++) {
            //         bytes[i] = binaryString.charCodeAt(i);
            //     }
            //     // Load PDF from memory
            //     pdf = await pdfjsLib.getDocument({
            //         data: bytes
            //     }).promise;
            //     console.log("Total pages:", pdf.numPages);
            // } else {
            pdf = await pdfjsLib.getDocument(url).promise;
            // }
            console.log("url--------------------------------------------->", url)
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = "100%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);
                await page.render({ canvasContext: context, viewport }).promise;
            }
        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }

    render() {
        const { isLoading, itenaryList, exhibitionData, isOpen, itiPath, Note, ItneryDeatailIdObj } = this.state

        console.log("itenaryList-->", itenaryList, itiPath)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <VisitorHeader2 />
                <DelegateDrawer />
                <div className="page">
                    <div className="page-main">
                        <div className="main-content with-dr-container mt-3">
                            <div className="">
                                <div className=" width-dr-nav">
                                    <div className="row"> <DelegateTopMenu />
                                    </div>
                                </div>
                                {/* <div class="btn-aqua" style={{ marginLeft: '10px' }}>
                                    <p>  Itinerary Details</p>
                                </div> */}
                                {console.log('1970-01-01T16:30:00.000Z', new Date('1970-01-01T16:30:00.000Z').toUTCString())}
                                <div class="container-fluid">
                                    <div className="row mx-0">
                                        <div className="col-xl-12 p-0">
                                            <div className="alert d-flex align-items-center m-0 mb-3 mt-2" role="alert" style={{ backgroundColor: '#ffebe9', border: '1px solid #ffcdce', color: '#a12321', borderRadius: '4px', padding: '12px 16px', fontSize: '15px' }}>
                                                <i className="bi bi-info-circle me-3 mr-3" style={{ fontSize: '18px' }}></i>
                                                <div>
                                                    <strong style={{ fontWeight: '600' }}>Note:</strong> Organizer have rights to cancel your registration and any registration fee if paid will be returned as well.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 p-0 mb-2 text-right text-end mt-2">
                                            {itiPath ? <button
                                                className="btn btn-aqua"
                                                disabled={itiPath == '' || itiPath == null}
                                                onClick={() => this.onPrintClick()}
                                            >
                                                Print
                                            </button> : null}
                                        </div>
                                        {itiPath ? <div className="col-xl-12 p-0 a ">
                                            <div className="card rounded-0 pt-1 border-0 shadow-none">
                                                {/* <div class="card-body p-1" id="itinerary-pdf">
                                                    <div class="table-responsive" >
                                                        <table class="table border td-summery table-bordered mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: '200px' }} className="text-center">Date</th>
                                                                    <th style={{ width: '200px' }} className="text-center">
                                                                        IST Time (GMT+5:30)
                                                                    </th>
                                                                    <th>Activities</th>
                                                                </tr>
                                                            </thead>
                                                            < tbody >
                                                                {itenaryList.length > 0
                                                                    ? itenaryList.map((item, index) => (
                                                                        <tr key={index}>
                                                                            {item.rowspan != null && (
                                                                                <td style={{ width: '100px' }} rowSpan={item.rowspan}>
                                                                                    {item.Date ? (
                                                                                        <>
                                                                                            {moment(item.Date).format('Do MMM YYYY')}
                                                                                            <br />
                                                                                            <small>{moment(item.Date).format('dddd')}</small>
                                                                                        </>
                                                                                    ) : (
                                                                                        ''
                                                                                    )}
                                                                                </td>
                                                                            )}

                                                                            <td style={{ width: '100px' }}>
                                                                                {item.StartTime != null &&
                                                                                    item.StartTime !== '' &&
                                                                                    item.EndTime != null &&
                                                                                    item.EndTime !== ''
                                                                                    ? `${moment
                                                                                        .utc(new Date(item.StartTime).toUTCString())
                                                                                        .format('HH:mm')} to ${moment
                                                                                            .utc(new Date(item.EndTime).toUTCString())
                                                                                            .format('HH:mm')}`
                                                                                    : ''}{' '}
                                                                                (hrs)
                                                                            </td>

                                                                            {item.ArrangementType === 'Seminar' ? (
                                                                                <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                                    <ul className="p-0 m-0">
                                                                                        <li
                                                                                            className="p-0 m-0 d-flex justify-content-between"
                                                                                            style={{ listStyle: 'none' }}
                                                                                        >
                                                                                            <span>
                                                                                                Attend the {item.SeminarName} seminar,{' '}
                                                                                                {item.Sspaneaker} as the speaker
                                                                                            </span>

                                                                                            <span
                                                                                                style={{ cursor: 'pointer' }}
                                                                                                onClick={() => this.onPop(item)}
                                                                                            >
                                                                                                <i
                                                                                                    title={item.Note ? "Update Note" : "Add Note"}
                                                                                                    className={
                                                                                                        item.Note
                                                                                                            ? 'bi bi-file-earmark-check-fill'
                                                                                                            : 'bi bi-journal-plus'
                                                                                                    }
                                                                                                ></i>
                                                                                            </span>
                                                                                        </li>

                                                                                        {item.Note && (
                                                                                            <li
                                                                                                style={{
                                                                                                    listStyle: 'none',
                                                                                                    marginTop: '5px'
                                                                                                }}
                                                                                            >
                                                                                                <span
                                                                                                    className="text-aqua"
                                                                                                    style={{
                                                                                                        display: 'block',
                                                                                                        maxWidth: '100%',
                                                                                                        whiteSpace: 'normal',
                                                                                                        wordBreak: 'break-word',
                                                                                                        overflowWrap: 'break-word',
                                                                                                        fontSize: '14px'
                                                                                                    }}
                                                                                                >
                                                                                                    Note: {item.Note}
                                                                                                </span>
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>
                                                                                </td>
                                                                            ) : item.ArrangementType === 'B2B Meeting' ? (
                                                                                <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                                    <ul className="p-0 m-0">
                                                                                        <li
                                                                                            className="p-0 m-0 d-flex justify-content-between"
                                                                                            style={{ listStyle: 'none' }}
                                                                                        >
                                                                                            <span>
                                                                                                B2B Meeting at {item.B2BLocation} with{' '}
                                                                                                {item.PersonName}, {item.CompanyName}
                                                                                            </span>

                                                                                            <span
                                                                                                style={{ cursor: 'pointer' }}
                                                                                                onClick={() => this.onPop(item)}
                                                                                            >
                                                                                                <i
                                                                                                    title={item.Note ? "Update Note" : "Add Note"}
                                                                                                    className={
                                                                                                        item.Note
                                                                                                            ? 'bi bi-file-earmark-check-fill'
                                                                                                            : 'bi bi-journal-plus'
                                                                                                    }
                                                                                                ></i>
                                                                                            </span>
                                                                                        </li>

                                                                                        {item.Note && (
                                                                                            <li
                                                                                                style={{
                                                                                                    listStyle: 'none',
                                                                                                    marginTop: '5px'
                                                                                                }}
                                                                                            >
                                                                                                <span
                                                                                                    className="text-aqua"
                                                                                                    style={{
                                                                                                        display: 'block',
                                                                                                        maxWidth: '100%',
                                                                                                        whiteSpace: 'normal',
                                                                                                        wordBreak: 'break-word',
                                                                                                        overflowWrap: 'break-word',
                                                                                                        fontSize: '14px'
                                                                                                    }}
                                                                                                >
                                                                                                    Note: {item.Note}
                                                                                                </span>
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>
                                                                                </td>
                                                                            ) : item.ArrangementType === 'Invitation Event' ? (
                                                                                <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                                    <ul className="p-0 m-0">
                                                                                        <li
                                                                                            className="p-0 m-0 d-flex justify-content-between"
                                                                                            style={{ listStyle: 'none' }}
                                                                                        >
                                                                                            <span>
                                                                                                {item.InvitationTypeName} at{' '}
                                                                                                {item.InvitationPlace}
                                                                                            </span>

                                                                                            <span
                                                                                                style={{ cursor: 'pointer' }}
                                                                                                onClick={() => this.onPop(item)}
                                                                                            >
                                                                                                <i
                                                                                                    title={item.Note ? "Update Note" : "Add Note"}
                                                                                                    className={
                                                                                                        item.Note
                                                                                                            ? 'bi bi-file-earmark-check-fill'
                                                                                                            : 'bi bi-journal-plus'
                                                                                                    }
                                                                                                ></i>
                                                                                            </span>
                                                                                        </li>

                                                                                        {item.Note && (
                                                                                            <li
                                                                                                style={{
                                                                                                    listStyle: 'none',
                                                                                                    marginTop: '5px'
                                                                                                }}
                                                                                            >
                                                                                                <span
                                                                                                    className="text-aqua"
                                                                                                    style={{
                                                                                                        display: 'block',
                                                                                                        maxWidth: '100%',
                                                                                                        whiteSpace: 'normal',
                                                                                                        wordBreak: 'break-word',
                                                                                                        overflowWrap: 'break-word',
                                                                                                        fontSize: '14px'
                                                                                                    }}
                                                                                                >
                                                                                                    Note: {item.Note}
                                                                                                </span>
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>
                                                                                </td>
                                                                            ) : (
                                                                                <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                                    <ul className="p-0 m-0">
                                                                                        <li
                                                                                            className="p-0 m-0 d-flex justify-content-between"
                                                                                            style={{
                                                                                                alignItems: "flex-start",
                                                                                                listStyle: "none",
                                                                                                width: "100%",
                                                                                                gap: "10px"
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                style={{
                                                                                                    flex: 1,
                                                                                                    minWidth: 0,              // Important for flex wrapping
                                                                                                    wordBreak: "break-word",
                                                                                                    overflowWrap: "break-word",
                                                                                                    whiteSpace: "normal"
                                                                                                }}
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: `${item.HtmlContent != null
                                                                                                        ? item.HtmlContent
                                                                                                        : ''
                                                                                                        }<br/>${item.MapUrl != null
                                                                                                            ? item.MapUrl
                                                                                                            : ''
                                                                                                        }`
                                                                                                }}
                                                                                            ></div>

                                                                                            <span
                                                                                                style={{ cursor: 'pointer' }}
                                                                                                onClick={() => this.onPop(item)}
                                                                                            >
                                                                                                <i
                                                                                                    title={item.Note ? "Update Note" : "Add Note"}
                                                                                                    className={
                                                                                                        item.Note
                                                                                                            ? 'bi bi-file-earmark-check-fill'
                                                                                                            : 'bi bi-journal-plus'
                                                                                                    }
                                                                                                ></i>
                                                                                            </span>
                                                                                        </li>

                                                                                        {item.Note && (
                                                                                            <li
                                                                                                style={{
                                                                                                    listStyle: 'none',
                                                                                                    marginTop: '5px'
                                                                                                }}
                                                                                            >
                                                                                                <span
                                                                                                    className="text-aqua"
                                                                                                    style={{
                                                                                                        display: 'block',
                                                                                                        maxWidth: '100%',
                                                                                                        whiteSpace: 'normal',
                                                                                                        wordBreak: 'break-word',
                                                                                                        overflowWrap: 'break-word',
                                                                                                        fontSize: '14px'
                                                                                                    }}
                                                                                                >
                                                                                                    Note: {item.Note}
                                                                                                </span>
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))
                                                                    : (
                                                                        <tr style={{ backgroundColor: '#f3f3f3' }}>
                                                                            <td colSpan={3}>No Records Found</td>
                                                                        </tr>
                                                                    )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div> */}
                                                {itiPath ? <div
                                                    id="pdf-container"
                                                    ref={this.pdfContainerRef}
                                                    style={{
                                                        width: "100%",
                                                        height: "80vh",       // keeps it scrollable inside card
                                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                                    }}
                                                ></div> : <></>}
                                            </div>
                                        </div> :
                                            <div class="card border p-0 mt-1">
                                                <h5 class="card-header bg-light p-3" style={{ justifyContent: 'center' }}>No itinerary added from organizer</h5>
                                            </div>}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </div >

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => this.setState({ isOpen: false, Note: '' })}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    ariaHideApp={false}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header text-white">
                                <h6 className="modal-title">{ItneryDeatailIdObj.ItineraryNoteID ? 'Update' : 'Add'} Note</h6>
                                <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ isOpen: false, Note: '' })} />
                            </div>
                            <div className="modal-body">
                                <div className="col-xl-12 mb-3">
                                    <label>Note</label>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        cols={5}
                                        rows={8}
                                        value={Note}
                                        onChange={(e) =>
                                            this.setState({ Note: e.target.value })
                                        }
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-aqua" onClick={() => this.insertUpdateItineraryNote()}>
                                    Submit
                                </button>
                                <button className="btn btn-gray" onClick={() => this.setState({ isOpen: false, Note: '' })}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action, payment_action, getItenaryUser_action,
    deleteVisaDoc_action, getVisitorRegistrationCredentials_action, getDrawerDetails_action, getCoordinatorVisitor_action, insertUpdateItineraryNote_action, getItineraryNoteDetails_action
})(ItenaryUser))